module.exports = __webpack_public_path__ + "static/preview-tabs-position-vertical-0b6f102c5b22639260d07564dabdbc00.png";